import React, {useEffect} from 'react'
import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function HomeBanner() {
    useEffect(() => {
        // Fancybox.bind('[data-fancybox="gallery-a"]', {
        //     Toolbar: false, // Removes the top toolbar
        //     Carousel: {
        //         Dots: false, // Hides dots at the bottom
        //         Navigation: false, // Removes prev/next buttons
        //     },
        //     groupAttr: false,
        // });
        Fancybox.bind('[data-fancybox="single"]', {
            groupAttr: false,
          });
    
        return () => {
          Fancybox.destroy();
        };
      }, []);

    return (
        <>
        
            <section className="home banner" id="banner">
                <div className="row ">
                    <div className="container">
                        <div className="banne-wrap">
                            <div className="banner-text wow fadeInLeft">
                                <h1>Snapshot <span className="red">Videos</span></h1>
                                <div className="banner-image mobile">
                                    {/* <a data-fancybox="single" data-src="/images/video-1.mp4" className="popup popup-btn"> */}
                                        {/* <!-- <video controls>
                                                    <source src="images/video-1.mp4" type="video/mp4">
                                                </video> -->
                                                <!-- <img src="./images/banner-right-image.jpg" alt="banner right image"> --> */}
                                    {/* </a> */}
                                    <img src="./images/bannerImage.png" alt="banner right image" />
                                </div>
                                <p>Quick, Engaging Updates for
                                    Your Members</p>
                                <a href="#lets-discuss-section" className="btn order-btn">Schedule a Call</a>
                            </div>
                            <div className="banner-image desktop wow fadeInRight">
                                {/* <a data-fancybox="single" href="images/video-1.mp4" className="popup popup-btn"> */}
                                <a data-fancybox="single" href="https://vimeo.com/1104192197" className="popup popup-btn">
                                    {/* <!-- <video controls>
                                                <source src="images/video-1.mp4" type="video/mp4">
                                            </video> -->
                                            <!-- <img src="./images/banner-right-image.jpg" alt="banner right image"> --> */}
                                </a>
                                <img src="./images/bannerImage.png" alt="banner right image" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
